import styled from 'styled-components';

import {
  ReactComponent as MapPointer
 } from "../../assets/icons/map-pointer.svg"
 import {
   ReactComponent as Id
 } from '../../assets/icons/id-icon.svg'
 import {
   ReactComponent as Certified
 } from '../../assets/icons/certified-icon.svg'
 import {
   ReactComponent as CreditCard
 } from '../../assets/icons/credit-card-icon.svg'
 import {
   ReactComponent as CirclePlus
 } from '../../assets/icons/circle-plus-icon.svg'

export const Container = styled.section`
  width: 100%;
  height: fit-content;
`

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 30px 50px;

  @media (max-width: 1170px){
    width: 100%;
    margin-left: 0;
    padding: 15px 20px 100px;
  }
`

export const Info = styled.article`
  width: 100%;
  max-width: 1400px;
  height: fit-content;
  padding: 34.2px 30.5px 37.8px;

  background-color: var(--bluef0);
  border-radius: 22px;
`

export const BlueParagraph = styled.p`
  max-width: 876px;

  font-size: 1.5625rem;
  font-weight: normal;
  color: var(--blue00);
`

export const GrayParagraph = styled.p`
  max-width: 825px;
  margin-top: 25px;

  font-size: 1.5rem;
  font-weight: lighter;
  color: var(--gray25);
`

export const DocsForm = styled.form`
  width: 100%;
  max-width: 660.5px;
  margin-top: 32px;
  padding: 45.5px 0px 86.7px;

  background-color: var(--bluef0);
  border-radius: 53px;
`

export const FormWrapper = styled.div`
  width: 90%;
  max-width: 520px;
  height: fit-content;
  margin: 0 auto;
`

export const FormLabel = styled.label`
  width: 100%;
  height: fit-content;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 19.7px;

 > svg {
  height: 34px;
  width: auto;

  fill: var(--blue00);
 }

 &:not(:first-child) {
    margin-top: 50px;
  }
`

export const LabelHeader = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--blue00);
`

export const TextInput = styled.input`
  width: 100%;
  max-width: 460.59px;
  height: 65.41px;
  margin: 21px 0 25px;
  padding: 0 28.6px;

  font-size: 1.25rem;
  color: var(--blue00);
  border-radius: 7px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.27);
  border: 0;
  outline: none;

  &::placeholder {
    color: var(--grayad);
  }
`

export const SelectWrapper = styled.div`
  width: 100%;
  max-width: 267px;
  margin: 30.6px 0 31px;
`

export const TextDetails = styled.dd`
  width: 100%;
  max-width: 429px;
  margin: 26.3px 0 43.5px;

  font-size: 1.25rem;
  font-weight: lighter;
  line-height: 34px;
  color: var(--blue3d);
`

export const PlusContainer = styled.div`
  width: 100%;
  max-width: 320px;
  height: fit-content;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
`

export const PlusButton = styled.button`
  width:  53.59px;
  height: 57.41px;

  border: 0;
  background-color: transparent;
  cursor: pointer;
`

export const SubmitButton = styled.button`
  width: 100%;
  max-width: 502.76px;
  height: 82.21px;
  margin-top: 59px;

  font-size: 1.625rem;
  color: #fff;
  border-radius: 45px;
  border: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.27);
  background-color: var(--blue00);
  cursor: pointer;
  transition: filter 0.2s, opacity 0.2s;

  &:not(:disabled):hover {
    filter: brightness(1.1);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`

export const SelfieLabelWrapper = styled.label`
  > button:active {
    pointer-events: none;
  }
`

export const MapPointerIcon = styled(MapPointer)`
  width: 27.9px;
  height: 41.85px;
`

export const IDIcon = styled(Id)`
  width:  45.34px;
  height: 34px;
`

export const CertifiedIcon = styled(Certified)`
  width:  41.69px;
  height: 40.09px;

  fill: var(--blue00);
`

export const CreditCardIcon = styled(CreditCard)`
  width:  39.96px;
  height: 31.4px;
`

export const CirclePlusIcon = styled(CirclePlus)`
  width:  53.59px;
  height: 57.41px;
`
